import { SkeletonCard, Stack, Typography } from '@optimus-web/core';
import { OptimusTextKey, useLocalization } from '@optimus-web/localization';
import { ChartStates } from '../../types';

export const ChartState = ({ empty, error }: ChartStates) => {
    const { t } = useLocalization();

    if (empty) {
        return (
            <Stack itemAlignment="center" alignment="center" distribution="stretch" fill>
                <Typography textStyle="bodySmall" align="center" as="div">
                    {(typeof empty === 'object' && empty.message) || t(OptimusTextKey.ChartEmptyDefaultMessage)}
                </Typography>
            </Stack>
        );
    }

    if (error) {
        return (
            <Stack itemAlignment="center" alignment="center" distribution="stretch" fill>
                <Typography textStyle="bodySmall" align="center" as="div">
                    {(typeof error === 'object' && error.message) || t(OptimusTextKey.ChartErrorDefaultMessage)}
                </Typography>
            </Stack>
        );
    }

    return (
        <Stack itemAlignment="center" alignment="center" distribution="stretch" fill>
            <SkeletonCard />
        </Stack>
    );
};
